module.exports = __webpack_public_path__ + "img/type_img05.57d4b2f3.png";